<template>
    <div class="grid">
        <div class="grid-content">
            <h1>
                Bienvenido
                <u>Owner</u>
            </h1>
        </div>
        <div class="grid-content">
            <div class="row">
                <div class="col-lg-4">
                    <vc-donut :sections="sections1">80%</vc-donut>
                </div>
                <div class="col-lg-4">
                    <vc-donut :sections="sections2">20%</vc-donut>
                </div>
                <div class="col-lg-4">
                    <vc-donut :sections="sections3">30%</vc-donut>
                </div>
            </div>
        </div>
        <div class="grid-content">
            <div class="row">
                <div class="col-lg-4">
                    <vc-donut :sections="sections4">25%</vc-donut>
                </div>
                <div class="col-lg-4">
                    <vc-donut :sections="sections5">10%</vc-donut>
                </div>
                <div class="col-lg-4">
                    <vc-donut :sections="sections6">20%</vc-donut>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      sections1: [{ value: 80 },{ value: 0 }, { value: 0 }, { value: 0 }],
      sections2: [{ value: 0 }, { value: 20 }, { value: 0 }, { value: 0 }],
      sections3: [{ value: 0 }, { value: 0 }, { value: 30 }, { value: 0 }],
      sections4: [{ value: 0 }, { value: 0 }, { value: 0 }, { value: 25 }],
      sections5: [{ value: 10 },{ value: 0 }, { value: 0 }, { value: 0 }],
      sections6: [{ value: 0 }, { value: 20 }, { value: 0 }, { value: 0 }]
    };
  },
  computed: {
    valueOfPie() {}
  },
  methods: {}
};
</script>

<style scoped>

.grid {
  display: grid;
  grid-template-columns: 1fr 77% 1fr;
  margin-top: 80px;
  grid-gap: 40px;
}

.grid-content {
  grid-column: 2/3;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/children/Home.vue